export const propertiesActionTypes = {
    CHANGE_PROPERTY: 'CHANGE_PROPERTY',
    CHANGE_PROPERTIES: 'CHANGE_PROPERTIES',
}

export function propertiesReducer( properties, action ) {
    let updatedProperties = { ...properties };

    switch ( action.type ) {
        case propertiesActionTypes.CHANGE_PROPERTY:
            updatedProperties[ action.payload.name ] = action.payload.value;
            break;

        case propertiesActionTypes.CHANGE_PROPERTIES:
            for ( const newProperty of action.payload ) {
                updatedProperties[ newProperty.name ] = newProperty.value;
            }
            break;
        default:
            throw new Error( `Unknown action: [${ action.type }]` );
    }

    return updatedProperties;
}
